import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { TopicService } from "../../topic-player/services/topic.service";

@Injectable({
  providedIn: 'root'
})

export class TopicResolver  {

  constructor(private topicService: TopicService, @Inject(LOCALE_ID) private localeId: string) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const topicSlug = route.params['topic-slug'];
    return this.topicService.getTopicBySlugAndLocale(topicSlug, this.localeId);
  }
}